import React from 'react';

const TestimonialItem = ({ data }) => {
  return (
    <div className="relative shadow-lg bg-white border-2 border-[#F4F7FA] px-6 flex flex-col items-center rounded-xl space-y-6 min-h-96 md:min-h-[410px] h-full py-10 hover:shadow-xl hover:border-dark-teal-700/20 transition-all duration-300 hover:-translate-y-1 group">
      
      {/* Quote decoration */}
      <div className="absolute -top-3 left-6 w-6 h-6 bg-dark-teal-700 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
        <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 24 24">
          <path d="M6.5 10c-.223 0-.437.034-.65.065.069-.232.14-.468.254-.68.114-.308.292-.575.469-.844.148-.291.409-.488.601-.737.201-.242.475-.403.692-.604.213-.21.492-.315.714-.463.232-.133.434-.28.65-.35l.539-.222.474-.197-.485-1.938-.597.144c-.191.048-.424.104-.689.171-.271.05-.56.187-.882.312-.318.142-.686.238-1.028.466-.344.218-.738.414-1.091.692-.707.606-1.482 1.288-1.932 2.187-.469.918-.591 2.053-.591 3.249 0 .657.098 1.299.308 1.914.22.632.568 1.213 1.043 1.707.462.481 1.01.842 1.6 1.066.598.235 1.236.375 1.884.375.676 0 1.339-.188 1.95-.523.595-.346 1.129-.819 1.574-1.377.453-.565.81-1.211 1.073-1.893.253-.64.405-1.319.405-2.005 0-.716-.174-1.388-.523-2.022-.37-.656-.895-1.218-1.548-1.651C8.235 10.344 7.368 10 6.5 10z"/>
          <path d="M17.5 10c-.223 0-.437.034-.65.065.069-.232.14-.468.254-.68.114-.308.292-.575.469-.844.148-.291.409-.488.601-.737.201-.242.475-.403.692-.604.213-.21.492-.315.714-.463.232-.133.434-.28.65-.35l.539-.222.474-.197-.485-1.938-.597.144c-.191.048-.424.104-.689.171-.271.05-.56.187-.882.312-.318.142-.686.238-1.028.466-.344.218-.738.414-1.091.692-.707.606-1.482 1.288-1.932 2.187-.469.918-.591 2.053-.591 3.249 0 .657.098 1.299.308 1.914.22.632.568 1.213 1.043 1.707.462.481 1.01.842 1.6 1.066.598.235 1.236.375 1.884.375.676 0 1.339-.188 1.95-.523.595-.346 1.129-.819 1.574-1.377.453-.565.81-1.211 1.073-1.893.253-.64.405-1.319.405-2.005 0-.716-.174-1.388-.523-2.022-.37-.656-.895-1.218-1.548-1.651C19.235 10.344 18.368 10 17.5 10z"/>
        </svg>
      </div>

      {/* Header with name, designation, and rating */}
      <div className="flex items-start lg:items-center gap-3 w-full">
        <div className="relative flex-1">
          <div className="font-PlusJakartaSans font-bold text-base text-dark-teal-700 capitalize leading-tight group-hover:text-dark-teal-800 transition-colors duration-300">
            {data.name}
          </div>
          <div className="font-Inter text-xs text-slate-700 capitalize mt-1 group-hover:text-slate-800 transition-colors duration-300">
            {data.designation}
          </div>
        </div>
        
        {/* Rating stars */}
        {/* <div className="flex gap-0.5">
          {[...Array(5)].map((_, i) => (
            <svg 
              key={i} 
              className="w-4 h-4 text-yellow-400 fill-current group-hover:scale-110 transition-transform duration-200" 
              style={{ transitionDelay: `${i * 50}ms` }}
              viewBox="0 0 24 24"
            >
              <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
            </svg>
          ))}
        </div> */}
      </div>

      {/* Testimonial content */}
      <div 
        dangerouslySetInnerHTML={{ __html: data.description }} 
        className="text-sm xl:text-base font-Inter text-slate-800 italic font-medium leading-relaxed flex-1 group-hover:text-slate-900 transition-colors duration-300 text-center"
      />
      
      {/* Bottom accent line */}
      <div className="w-12 h-1 bg-dark-teal-700 rounded-full group-hover:w-20 group-hover:bg-dark-teal-800 transition-all duration-300"></div>

      {/* Subtle background pattern on hover */}
      <div className="absolute inset-0 bg-gradient-to-br from-transparent via-transparent to-[#F4F7FA]/10 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none"></div>
    </div>
  );
};

export default TestimonialItem;